import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";
import FrlCategoryGroup from "../../components/frl-category-group";

export default <template>
  <div class="category_groups">
    {{#each @controller.model.category_groups as |categoryGroup|}}
      <FrlCategoryGroup
        @categoryGroup={{categoryGroup}}
        @groups={{@controller.model.groups}}
        @availableCategoryIds={{@controller.availableCategoryIds}}
        @editCategoryGroup={{@controller.editCategoryGroup}}
        @deleteCategoryGroup={{@controller.deleteCategoryGroup}}
      />
    {{/each}}
  </div>

  <div class="frl-actions">
    <DButton
      @action={{@controller.addCategoryGroup}}
      @label="flexible_rate_limits.admin.add_category_group"
      @icon="plus"
    />
  </div>

  <div class="frl-actions">
    <DButton
      @action={{@controller.saveCategoryGroups}}
      @label="flexible_rate_limits.admin.save"
      @icon="check"
      @disabled={{@controller.disableSave}}
      class="btn-primary"
    />

    <DButton
      @action={{@controller.reload}}
      @label="flexible_rate_limits.admin.reload"
      @icon="arrow-rotate-left"
      class="btn-primary"
    />
  </div>

  <div class="frl-global-rate-limits">
    <h3>{{i18n "flexible_rate_limits.admin.global_rate_limits"}}</h3>
    <table class="table">
      <tbody>
        {{#each @controller.model.site_settings as |setting|}}
          <tr>
            <td><strong>{{setting.name}}</strong></td>
            <td><strong>{{setting.value}}</strong></td>
            <td>{{setting.description}}</td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </div>
</template>;
